import React, { useMemo, useState, useRef } from "react";
import PropTypes from "prop-types";
import ArrowDefault from "../../../styles/default/assets/icons/ic_pulse_arrow_down_default.svg";
import ArrowActive from "../../../styles/default/assets/icons/ic_pulse_arrow_down_active.svg";

const ModernizedAccordion = ({
  field: { name, type, params, title },
  fieldRef,
  children
}) => {
  const isOpen = params?.includes("TDFieldOptionNotCollapsed");
  const regionRef = useRef(null);
  const [isRegionOpen, setRegionOpen] = useState(isOpen || false);
  const [isExpanded, setExpanded] = useState(isOpen || false);
  const [isCollapsed, setCollapsed] = useState(!isOpen);

  const getClassName = useMemo(
    () => `${name} ${type} ${params ? params.split("|").join(" ") : ""} `,
    [name, type, params]
  );

  const handleClick = () => {
    if (isExpanded) {
      // Rotate arrow button
      setCollapsed(prev => !prev);
      // Change content element height with transition
      setRegionOpen(prev => !prev);
      // Remove content wrapper from DOM
      setTimeout(() => setExpanded(prev => !prev), 300);
      return;
    }
    // Rotate arrow button
    setCollapsed(prev => !prev);
    // Add content wrapper to DOM
    setExpanded(prev => !prev);
    // Change content element height with transition
    setTimeout(() => setRegionOpen(prev => !prev), 0);
  };

  return (
    <div
      ref={fieldRef}
      className={`modernized-accordion-container-web-sdk ${getClassName}`}
    >
      <button
        type='button'
        id={`accordion-${name}`}
        className={`modernized-accordion-trigger-web-sdk ${
          isCollapsed ? "" : "expanded"
        }`}
        onClick={handleClick}
        aria-expanded={isExpanded}
        aria-controls={`accorgion-area-${name}`}
      >
        <span className='accordion-title-web-sdk'>{title}</span>
        <span className='accordion-icon-web-sdk' aria-hidden='true'>
          <img src={isCollapsed ? ArrowDefault : ArrowActive} alt='' />
        </span>
      </button>
      {isExpanded && (
        <div
          ref={regionRef}
          id={`accorgion-area-${name}`}
          className='modernized-accordion-content-web-sdk'
          role='region'
          aria-labelledby={`accordion-${name}`}
          style={
            isRegionOpen
              ? { height: regionRef?.current?.scrollHeight }
              : { height: "0px" }
          }
        >
          {children}
        </div>
      )}
    </div>
  );
};

ModernizedAccordion.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    params: PropTypes.string,
    title: PropTypes.string.isRequired
  }),
  fieldRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.node })
  ]),
  children: PropTypes.node
};

export default ModernizedAccordion;
